module.exports = __webpack_public_path__ + "static/img/homecard_quality.2834c346.jpg";